// Utility functions to display test results in the sample app UI
export function getChartInitialConfig(mediaType) {
  const plotBands = {
    audio: [
      {
        from: 30000,
        to: 35000,
        color: 'rgba(68, 170, 213, 0.1)',
        label: {
          text: 'Adequate',
          style: {
            color: '#606060',
            fontSize: '8px'
          }
        }
      },
      {
        from: 35000,
        to: 40000,
        color: 'rgba(0, 0, 0, 0)',
        label: {
          text: 'Excellent',
          style: {
            color: '#606060',
            fontSize: '8px'
          }
        }
      }
    ],
    video: [
      {
        from: 200000,
        to: 350000,
        color: 'rgba(68, 170, 213, 0.1)',
        label: {
          text: 'Adequate',
          style: {
            color: '#606060',
            fontSize: '8px'
          }
        }
      },
      {
        from: 350000,
        to: 600000,
        color: 'rgba(0, 0, 0, 0)',
        label: {
          text: 'Good',
          style: {
            color: '#606060',
            fontSize: '8px'
          }
        }
      },
      {
        from: 600000,
        to: 2000000,
        color: 'rgba(68, 170, 213, 0.1)',
        label: {
          text: 'Excellent',
          style: {
            color: '#606060',
            fontSize: '8px'
          }
        }
      }
    ]
  };

  return {
    chart: {
      type: 'spline',
      height: 300
    },
    title: {
      text: `${mediaType} bitrate stability`,
      style: { fontSize: '14px' }
    },
    subtitle: {
      text: '',
      style: { fontSize: '12px' }
    },
    xAxis: {
      title: {
        text: 'Time elapsed (sec)',
        style: { fontSize: '8px' }
      },
      labels: {
        style: { fontSize: '8px' }
      }
    },
    yAxis: {
      title: {
        text: 'Bitrate (KBps)',
        style: { fontSize: '8px' }
      },
      min: 0,
      minorGridLineWidth: 0,
      gridLineWidth: 0,
      alternateGridColor: null,
      plotBands: plotBands[mediaType],
      labels: {
        style: { fontSize: '8px' }
      }
    },
    tooltip: {
      headerFormat: '<b>{series.name}</b><br>',
      pointFormat: '{point.y:.2f} kBps'
    },
    plotOptions: {
      spline: {
        lineWidth: 2,
        states: {
          hover: {
            lineWidth: 3
          }
        },
        marker: {
          enabled: false
        },
        pointInterval: 1, // one hour
        color: '#0099CC'
      }
    },
    series: [
      {
        name: 'bitrate',
        data: [0],
        animation: false
      }
    ],
    legend: false
  };
}

export function convertFailedTestsToString(failedTests: any) {
  const failureTypes: any = [];
  for (let i = 0; i < failedTests.length; i++) {
    failureTypes.push(failedTests[i]?.type);
  }
  const mappedFailures: any = [];
  if (failureTypes.indexOf('api') > -1) {
    mappedFailures.push('OpenTok API server');
  }
  if (failureTypes.indexOf('messaging') > -1) {
    mappedFailures.push('OpenTok messaging WebSocket');
  }
  if (failureTypes.indexOf('media') > -1) {
    mappedFailures.push('OpenTok Media Router');
  }
  if (failureTypes.indexOf('logging') > -1) {
    mappedFailures.push('OpenTok logging server');
  }
  return mappedFailures.join(', ');
}

export function rateMosScore(mos) {
  if (mos >= 3.8) {
    return 'Excellent';
  }
  if (mos >= 3.1) {
    return 'Good';
  }
  if (mos >= 2.4) {
    return 'Fair';
  }
  if (mos >= 1.7) {
    return 'Poor';
  }
  return 'Bad';
}

export function graphIntermediateStats(chart, prevBitsReceived, resultCount, mediaType, stats) {
  const mediaStats = stats[mediaType];

  const bitsReceived = mediaStats && mediaStats.bytesReceived ? mediaStats.bytesReceived * 8 : 0;
  resultCount[mediaType]++;

  chart.series[0].addPoint(
    {
      x: resultCount[mediaType],
      y: bitsReceived - prevBitsReceived[mediaType]
    },
    true,
    false
  );

  const chartTitle =
    stats.phase === 'audio-only' && mediaType === 'video' ? 'Testing audio-only stream' : `Bitrate over ${resultCount[mediaType]}sec`;

  chart.setTitle(null, { text: chartTitle });

  prevBitsReceived[mediaType] = bitsReceived;
}
